<template>
  <div class="report">
    <h2>Báo cáo kết quả gọi của nhân viên</h2>

    <!-- FILTER -->
    <div class="row mb-3 g-2">
      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Từ ngày</label>
        <input
          type="date"
          class="form-control"
          v-model="saleFilter.fromDate"
        />
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Đến ngày</label>
        <input
          type="date"
          class="form-control"
          v-model="saleFilter.toDate"
        />
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6">
        <label class="font-weight-bold">Nhân viên</label>
        <input
          type="text"
          class="form-control"
          v-model="saleFilter.saleId"
          placeholder="ID sale"
        />
      </div>

      <!-- BUTTON -->
      <div class="col-12 d-flex flex-wrap gap-2 mt-4">
        <b-button variant="primary" @click="searchSale">
          Tìm kiếm
        </b-button>

        <b-button variant="outline-success" @click="resetFilter">
          <i class="fa fa-refresh mr-1"></i> Đặt lại
        </b-button>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-wrapper">
      <b-table
        bordered
        hover
        head-variant="dark"
        :items="saleTable"
        :fields="fields"
      >
        <!-- STT -->
        <template #cell(stt)="data">
          {{ (currentPage - 1) * perPage + data.index + 1 }}
        </template>

        <!-- ACCEPTED -->
        <template #cell(accepted)="data">
          <span class="text-success font-weight-bold">
            {{ data.item.accepted }}
          </span>
        </template>

        <!-- REJECTED -->
        <template #cell(rejected)="data">
          <span class="text-danger font-weight-bold">
            {{ data.item.rejected }}
          </span>
        </template>

        <!-- CONVERT RATIO -->
        <template #cell(convertRatio)="data">
          <strong>{{ data.item.convertRatio }}%</strong>
        </template>
      </b-table>

      <!-- EMPTY -->
      <div
        v-if="saleTable.length === 0"
        class="text-center text-muted mt-3"
      >
        Không có dữ liệu
      </div>
    </div>

    <!-- PAGINATION -->
    <div
      class="d-flex justify-content-between mt-3 flex-wrap"
      v-if="total > 0"
    >
      <small class="text-muted">
        Hiển thị
        {{ (currentPage - 1) * perPage + 1 }}
        –
        {{ Math.min(currentPage * perPage, total) }}
        /
        {{ total }}
        bản ghi
      </small>

      <div class="d-flex">
        <b-form-select
          size="sm"
          v-model="selectedPerPage"
          :options="optionsPages"
          @change="changePerPage"
          class="mr-2"
          style="max-width: 100px"
        />

        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="perPage"
          size="sm"
          @change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      saleFilter: {
        fromDate: null,
        toDate: null,
        saleId: null
      },

      fields: [
        { key: 'saleId', label: 'ID' },
        { key: 'fullName', label: 'Nhân viên' },
        { key: 'totalTasks', label: 'Tổng cuộc gọi' },
        { key: 'ordered', label: 'Số khách đã đặt đơn' },
        { key: 'accepted', label: 'Đã kết nối' },
        { key: 'rejected', label: 'Từ chối' },
        { key: 'noAnswer', label: 'Không nghe máy' },
        { key: 'notCatch', label: 'Không liên lạc được' },
        { key: 'consultation_needed', label: 'Cần tư vấn thêm' },
        { key: 'convertRatio', label: 'Tỷ lệ thành công (%)' }
      ],

      saleTable: [],
      selectedPerPage: 20,
      perPage: 20,
      currentPage: 1,
      total: 0,

      optionsPages: [
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ]
    }
  },

  mounted() {
    this.fetchSaleReport()
  },

  methods: {
    searchSale() {
      this.currentPage = 1
      this.fetchSaleReport()
    },

    resetFilter() {
      this.saleFilter = {
        fromDate: null,
        toDate: null,
        saleId: null
      }
      this.currentPage = 1
      this.selectedPerPage = 20
      this.perPage = 20
      this.fetchSaleReport()
    },

    changePage(page) {
      this.currentPage = page
      this.fetchSaleReport()
    },

    changePerPage() {
      this.currentPage = 1
      this.perPage = this.selectedPerPage
      this.fetchSaleReport()
    },

    async fetchSaleReport() {
      const res = await apiClient.get('/api/v1/admin/report/sale', {
        params: {
          fromDate: this.saleFilter.fromDate,
          toDate: this.saleFilter.toDate,
          saleId: this.saleFilter.saleId,
          perPage: this.perPage,
          currentPage: this.currentPage
        }
      })

      if (res?.data) {
        this.total = Number(res.data.total)
        this.saleTable = res.data.items.map(item => ({
          saleId: item.sale_id,
          fullName: item.full_name,
          totalTasks: item.total_tasks,
          ordered: item.ordered,
          accepted: item.accepted,
          rejected: item.rejected,
          noAnswer: item.no_answer,
          notCatch: item.not_catch,
          consultation_needed: item.consultation_needed,
          convertRatio: item.convert_ratio || 0
        }))
      }
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
}

.label-page {
  line-height: 34px;
}
</style>
